module.exports = __webpack_public_path__ + "assets/img/flag-sg.d9af8bac.svg";